export const FETCH_SEARCH_USER_REQUEST = 'FETCH_SEARCH_USER_REQUEST';
export const FETCH_SEARCH_USER_SUCCESS = 'FETCH_SEARCH_USER_SUCCESS';
export const FETCH_SEARCH_USER_FAILURE = 'FETCH_SEARCH_USER_FAILURE';

export const FETCH_MANAGE_ROLE_REQUEST = 'FETCH_MANAGE_ROLE_REQUEST';
export const FETCH_MANAGE_ROLE_SUCCESS = 'FETCH_MANAGE_ROLE_SUCCESS';
export const FETCH_MANAGE_ROLE_FAILURE = 'FETCH_MANAGE_ROLE_FAILURE';

export const FETCH_BAN_USER_REQUEST = 'FETCH_BAN_USER_REQUEST';
export const FETCH_BAN_USER_SUCCESS = 'FETCH_BAN_USER_SUCCESS';
export const FETCH_BAN_USER_FAILURE = 'FETCH_BAN_USER_FAILURE';

export const FETCH_REMOVE_BAN_USER_REQUEST = 'FETCH_REMOVE_BAN_USER_REQUEST';
export const FETCH_REMOVE_BAN_USER_SUCCESS = 'FETCH_REMOVE_BAN_USER_SUCCESS';
export const FETCH_REMOVE_BAN_USER_FAILURE = 'FETCH_REMOVE_BAN_USER_FAILURE';

export const FETCH_DELETE_USER_REQUEST = 'FETCH_DELETE_USER_REQUEST';
export const FETCH_DELETE_USER_SUCCESS = 'FETCH_DELETE_USER_SUCCESS';
export const FETCH_DELETE_USER_FAILURE = 'FETCH_DELETE_USER_FAILURE';

export const FETCH_ADD_FUND_REQUEST = 'FETCH_ADD_FUND_REQUEST';
export const FETCH_ADD_FUND_SUCCESS = 'FETCH_ADD_FUND_SUCCESS';
export const FETCH_ADD_FUND_FAILURE = 'FETCH_ADD_FUND_FAILURE';

export const FETCH_USER_DETAILS_REQUEST = 'FETCH_USER_DETAILS_REQUEST';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const FETCH_MANAGE_TOURNAMENT_LIST_REQUEST = 'FETCH_MANAGE_TOURNAMENT_LIST_REQUEST';
export const FETCH_MANAGE_TOURNAMENT_LIST_SUCCESS = 'FETCH_MANAGE_TOURNAMENT_LIST_SUCCESS';
export const FETCH_MANAGE_TOURNAMENT_LIST_FAILURE = 'FETCH_MANAGE_TOURNAMENT_LIST_FAILURE';

export const FETCH_ROLE_UPDATE_REQUEST = 'FETCH_ROLE_UPDATE_REQUEST';
export const FETCH_ROLE_UPDATE_SUCCESS = 'FETCH_ROLE_UPDATE_SUCCESS';
export const FETCH_ROLE_UPDATE_FAILURE = 'FETCH_ROLE_UPDATE_FAILURE';

export const FETCH_ADMIN_CREATE_TOURNAMENT_REQUEST = 'FETCH_ADMIN_CREATE_TOURNAMENT_REQUEST';
export const FETCH_ADMIN_CREATE_TOURNAMENT_SUCCESS = 'FETCH_ADMIN_CREATE_TOURNAMENT_SUCCESS';
export const FETCH_ADMIN_CREATE_TOURNAMENT_FAILURE = 'FETCH_ADMIN_CREATE_TOURNAMENT_FAILURE';

export const RESET_ADMIN_CREATE_TOURNAMENT_REQUEST = 'RESET_ADMIN_CREATE_TOURNAMENT_REQUEST';
